import "../styles/whatsapp.css";

const WhatsAppButton = () => {
    const phoneNumber = "918891064655";

    return (
        <a
            href={`https://wa.me/${phoneNumber}`}
            className="wa-root"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Chat on WhatsApp"
        >
            {/* Pulse rings */}
            <span className="wa-ring wa-ring-1" aria-hidden="true" />
            <span className="wa-ring wa-ring-2" aria-hidden="true" />

            {/* WhatsApp SVG icon — no library needed */}
            <svg
                className="wa-icon"
                viewBox="0 0 32 32"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
            >
                <path
                    d="M16 2C8.268 2 2 8.268 2 16c0 2.49.648 4.83 1.782 6.86L2 30l7.338-1.762A13.93 13.93 0 0 0 16 30c7.732 0 14-6.268 14-14S23.732 2 16 2zm0 25.5a11.44 11.44 0 0 1-5.834-1.596l-.418-.248-4.354 1.046 1.068-4.24-.272-.434A11.46 11.46 0 0 1 4.5 16C4.5 9.596 9.596 4.5 16 4.5S27.5 9.596 27.5 16 22.404 27.5 16 27.5zm6.29-8.61c-.344-.172-2.036-1.004-2.352-1.118-.316-.116-.546-.172-.776.172s-.892 1.118-1.092 1.348c-.2.23-.4.258-.744.086-.344-.172-1.452-.536-2.766-1.708-1.022-.912-1.712-2.038-1.912-2.382-.2-.344-.022-.53.15-.702.154-.154.344-.4.516-.6.172-.2.23-.344.344-.574.116-.23.058-.43-.028-.602-.086-.172-.776-1.872-1.064-2.562-.28-.67-.564-.58-.776-.59l-.66-.012c-.23 0-.602.086-.918.43s-1.204 1.176-1.204 2.868 1.232 3.328 1.404 3.558c.172.23 2.426 3.706 5.878 5.194.822.354 1.464.566 1.964.724.824.262 1.574.224 2.168.136.66-.098 2.036-.832 2.322-1.636.288-.804.288-1.492.202-1.636-.086-.144-.316-.23-.66-.4z"
                    fill="currentColor"
                />
            </svg>

            {/* Tooltip */}
            <span className="wa-tooltip">Chat with us</span>
        </a>
    );
};

export default WhatsAppButton;